import { render, staticRenderFns } from "./Sales-order-tile.vue?vue&type=template&id=5ce6fe86&scoped=true&"
import script from "./Sales-order-tile.vue?vue&type=script&lang=js&"
export * from "./Sales-order-tile.vue?vue&type=script&lang=js&"
import style0 from "./Sales-order-tile.vue?vue&type=style&index=0&id=5ce6fe86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce6fe86",
  null
  
)

export default component.exports